import * as React from "react";

import { cn } from "~/lib/utils";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

// AIDEV-NOTE: Design system spec — same chrome as TextField (white surface,
// 1px brand-forest-200 border, 8px radius, forest-800 focus ring at 12%
// opacity), vertical-resize only, body font.
const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ className, ...props }, ref) => (
        <textarea
            className={cn(
                "flex min-h-[80px] w-full resize-y rounded-lg border border-brand-forest-200 bg-white px-3.5 py-2.5 text-base sm:text-sm text-brand-forest-800 placeholder:text-brand-forest-800/40 transition-shadow focus:outline-none focus:border-brand-forest-300 focus:shadow-[0_0_0_3px_rgba(27,67,50,0.12)] disabled:cursor-not-allowed disabled:opacity-50",
                className,
            )}
            ref={ref}
            {...props}
        />
    ),
);
Textarea.displayName = "Textarea";

export { Textarea };
